import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, NavLink } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './MainNavbarMenu.css';
import logo from '../../assets/logo.svg';
import { FaMapMarkerAlt, FaPhone, FaLanguage, FaCode, FaShoppingCart } from 'react-icons/fa'; // Importing icons
import { useTranslation } from 'react-i18next';
import Switch from 'react-switch';
import RegionSwitcher from '../RegionSwitcher/RegionSwitcher';
import { useHistory } from 'react-router-dom';
import { GiFountainPen } from "react-icons/gi";


function MainNavbarMenu() {

  const [isSticky, setIsSticky] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const { i18n, t } = useTranslation();
  const [checked, setChecked] = useState(i18n.language === 'ga');
  const history = useHistory();

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
    const newLang = nextChecked ? 'ga' : 'en';
    i18n.changeLanguage(newLang);
    setExpanded(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleDropdownClose = () => {
    setExpanded(false);
  };

  const handleEnquireNow = (e) => {
    e.preventDefault();
    history.push('/contact-us#contact-form-section');
  }

  return (
    <Navbar className="sec-navbar" bg="light" expand="lg" expanded={expanded}>
      <Navbar.Brand className={` nav-brand-main`} as={Link} to="/">
        <img
          src={logo}
          className={`d-inline-block align-top logo-nav-main ${isSticky ? "logo-stuck" : "logo-not-stuck"}`}
          alt="title"
        />
      </Navbar.Brand>
      
      {/* Mobile Phone Icon */}
      <div className="mobile-phone-icon-container">
        <div className="mobile-phone-icon" title="Contact Us" onClick={handleEnquireNow}>
          <FaPhone /> <span className="mobile-phone-icon-text">Contact us</span>
        </div>
      </div>
      
      <Navbar.Toggle aria-controls="basic-navbar-nav navbar-toggle-hamburger" onClick={() => setExpanded(!expanded)}></Navbar.Toggle>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto margin-l basic-navbar-main-menu">
          <div className="nav-wrapper">
            <NavDropdown title="HANSA-FLEX Ireland" id="basic-nav-dropdown" className="no-arrow" onSelect={handleDropdownClose}>
              <NavDropdown.Item as={Link} to="/about/who-we-are">{t("Who we are")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/management">{t("Management")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/our-journey">{t("Journey")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/certificates">{t("Certificates")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/contact-us">{t("Contact us")}</NavDropdown.Item>
              {/* <NavDropdown.Item as={Link} to="/careers">Careers</NavDropdown.Item> */}
            </NavDropdown>
            <div className="nav-line"></div>
          </div>

          <div className="nav-wrapper">
            <NavDropdown title={t('HANSA-FLEX Group')} id="basic-nav-dropdown" className="no-arrow" onSelect={handleDropdownClose}>
              <NavDropdown.Item as={Link} to="/hansa-flex-group/management">{t('Management')}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/hansa-flex-group/annual-report">{t('Annual Report')}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/hansa-flex-group/history">{t('History')}</NavDropdown.Item>
              <Nav.Link href="https://www.hansa-flex.de/niederlassungssuche/" target="_blank" rel="noopener noreferrer" className='drop-menu-item-link drop-menu-item-ext-link'>
                {('Branch Search')}
              </Nav.Link>
              <NavDropdown title={t('Responsibility and Social Commitments')} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/hansa-flex-group/responsibility-and-social-commitments">{t('Responsibility and Social Commitments')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hansa-flex-group/responsibility-and-social-commitments/donations-instead-of-gifts">{t('Donations instead of gifts')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hansa-flex-group/responsibility-and-social-commitments/diversity">{t('Diversity')}</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown.Item as={Link} to="/hansa-flex-group/mission-statement-and-values">{t('Mission statement and values')}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/about/certificates">{t("Certificates")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/hansa-flex-group/associations">{t("Associations")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/hansa-flex-group/upcoming-events">{t("Measures")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/hansa-flex-group/60-years-of-hansa-flex">{t('60 years of HANSA-FLEX')}</NavDropdown.Item>
              <Nav.Link href="https://www.hansa-flex.de/en/company/" target="_blank" rel="noopener noreferrer" className='drop-menu-item-link drop-menu-item-ext-link'>
                {('More About HANSA-FLEX Group')}
              </Nav.Link>
            </NavDropdown>
            <div className="nav-line"></div>
          </div>
          <div className="nav-wrapper">
            <NavDropdown title={t('Products')} id="basic-nav-dropdown" className="no-arrow" onSelect={handleDropdownClose}>
              <NavDropdown title={t('Hoses and hose lines')} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/products/hoses-and-hose-lines">{t('Hoses and hose lines')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hoses-and-hose-lines/hose-line-configurator">{t('Hose line configurator')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hoses-and-hose-lines/hydraulic-hoses">{t('Hydraulic hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hoses-and-hose-lines/metal-hoses">{t('Metal hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hoses-and-hose-lines/industrial-hoses">{t('Industrial hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hoses-and-hose-lines/preformed-hoses">{t('Preformed hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hoses-and-hose-lines/extremely-high-pressure-hoses">{t('Extremely high-pressure hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hoses-and-hose-lines/ptfe-hoses">{t('PTFE hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hoses-and-hose-lines/hose-accessories">{t('Accessories')}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t('Pipelines')} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/products/pipelines">{t('Pipelines')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/pipelines/pipe-bends">{t('Pipebends')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/pipelines/pipe-end-processing">{t("Pipe-end processing")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/pipelines/expansion-joints">{t("Expansion joints")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Drive and control technology")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/products/drive-and-control-technology">{t("Drive and control technology")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/hydraulic-pumps">{t('Pumps')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/hydraulic-motors">{t('Hydraulic motors')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/hydraulic-cylinders">{t('Cylinders')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/switches-and-sensors">{t('Switches and sensors')}</NavDropdown.Item>
                <NavDropdown title={t("Valve technology")} id="nested-nav-dropdown" drop='end'>
                  <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/valve-technology">{t("Valve technology")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/valve-technology/pipeline-installation-valves">{t("Pipeline installation valves")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/valve-technology/cartridge-valves">{t("Cartridge valves")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/valve-technology/cetop-valves">{t("CETOP valves")}</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/measuring-technology">{t("Measuring technology")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/700-bar-heavy-load-hydraulics">{t("700 bar heavy load hydraulics")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/drive-and-control-technology/pressure-accumulators">{t("Pressure accumulators")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t('Hydraulic connection technology')} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/products/hydraulic-connection-technology">{t("Hydraulic connection technology")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hydraulic-connection-technology/hose-fittings">{t("Hose fittings")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hydraulic-connection-technology/pipe-fittings">{t("Pipe fittings")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hydraulic-connection-technology/adapters">{t("Adapters")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hydraulic-connection-technology/couplings">{t("Couplings")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hydraulic-connection-technology/ball-valves">{t("Ball valves")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/products/hydraulic-connection-technology/flanges">{t("Flanges")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown.Item as={Link} to="/products/sealing-technology">{t("Sealing technology")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/products/filtration">{t("Filtration")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/products/pneumatics">{t("Pneumatics")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/products/technical-information">{t("Technical information")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/products/approvals">{t("Approvals")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/products/catalogues">{t("Catalogues")}</NavDropdown.Item>

            </NavDropdown>
            <div className="nav-line"></div>
          </div>


          <div className="nav-wrapper">
            <NavDropdown title={t("Services")} id="basic-nav-dropdown" className="no-arrow" onSelect={handleDropdownClose}>
              <NavDropdown.Item as={Link} to="/services/mobile-rapid-hydraulic-service">{t("Mobile rapid hydraulic service")}</NavDropdown.Item>

              <NavDropdown title={t("Fluid management")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/services/fluid-management">{t("Fluid management")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/fluid-management/oil-analysis">{t("Oil analysis")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/fluid-management/oil-filtering-and-cleaning">{t("Oil filtering and cleaning")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Assembly and installation")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/services/assembly-and-installation">{t("Assembly and installation")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/assembly-and-installation/modernisation-and-optimisation">{t("Modernisation and optimisation")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/assembly-and-installation/plant-project-planning-and-management">{t("Plant project planning and management")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/assembly-and-installation/installation-of-pipe-and-hose-line-systems">{t("Installation of pipe and hose line systems")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Preventative maintenance")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/services/preventative-maintenance">{t("Preventative maintenance")}</NavDropdown.Item>
                <NavDropdown title={t("Hose management")} id="nested-nav-dropdown" drop='end'>
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/hose-management">{t("Hose management")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/hose-management/x-code-hose-identification-system">{t("X-CODE hose identification system")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/hose-management/x-code-manager">{t("X-CODE Manager")}</NavDropdown.Item>
                  {/* <NavDropdown title={t("X-CODE Manager")} id="nested-nav-dropdown" drop='end'> */}
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/hose-management/x-code-manager-licences">{t("Licences")}</NavDropdown.Item>
                  {/* </NavDropdown> */}
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/hose-management/service-packages">{t("Service packages")}</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title={t("Inspections")} id="nested-nav-dropdown" drop='end'>
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/inspections">{t("Inspections")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/inspections/dguv-inspection">{t("DGUV inspection")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/inspections/industrial-hose-inspection">{t("Industrial hose inspection")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/inspections/lifting-platforms-and-loading-bridges">{t("Lifting platforms and loading bridges")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/services/preventative-maintenance/inspections/pressure-accumulator-inspection">{t("Pressure accumulator inspection")}</NavDropdown.Item>
                </NavDropdown>
              </NavDropdown>

              <NavDropdown title={t("Repair and overhaul")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/services/repair-and-overhaul">{t("Repair and overhaul")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/repair-and-overhaul/hydraulic-cylinder-repair">{t("Hydraulic cylinder repair")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/repair-and-overhaul/pressure-accumulators-and-associated-systems">{t("Pressure accumulators and associated systems")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Digital services")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/services/digital-services">{t("Digital services")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/digital-services/scanner-solutions">{t("Scanner solutions")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/digital-services/edi-and-bmecat">{t("EDI and BMEcat")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Production")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/services/production">{t("Production")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/production/series-production">{t("Series production")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/production/customised-assembly">{t("Customised assembly")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Logistics solutions")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/services/logistics-solutions">{t("Logistics solutions")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/logistics-solutions/warehouse-management">{t("Warehouse management")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/logistics-solutions/kanban-delivery">{t("Kanban delivery")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/logistics-solutions/kitting">{t("Kitting")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/logistics-solutions/hydraulic-workshop-containers">{t("Hydraulic workshop containers")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/logistics-solutions/works-in-works">{t("Works-in-works")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Engineering")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/services/engineering">{t("Engineering")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/engineering/engineered-by-hansa-flex">{t("Engineered by HANSA-FLEX")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/engineering/hydraulic-unit-manufacture">{t("Hydraulic unit manufacture")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services/engineering/prototype-manufacture">{t("Prototype manufacture")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown.Item as={Link} to="/services/hydraulic-training-and-seminars">{t("Training and seminars")}</NavDropdown.Item>
            </NavDropdown>
            <div className="nav-line"></div>
          </div>


          {/* <div className="nav-wrapper">
            <NavLink as={Link} to="/news-and-events">News and Events</NavLink>
            <div className="nav-line"></div>
          </div> */}

          {/*<NavDropdown.Item href="#action/3.2">Dropdown Item 2</NavDropdown.Item>
        <NavDropdown.Item href="#action/3.3">Dropdown Item 3</NavDropdown.Item>

            </NavDropdown>
            <div className="nav-line"></div> 
          </div>*/}




          <div className="nav-wrapper">
            <NavLink as={Link} to="/careers" onClick={handleDropdownClose}>Careers</NavLink>
            <div className="nav-line"></div>
          </div>
          <hr />
          <div className="additional-nav-mobile-menu">
            <Nav.Link href="/contact-us" onClick={handleDropdownClose}>
              <FaPhone /> {t('Contact us')}
            </Nav.Link>
            {/* <div className='language-switcher'>
              <FaLanguage className="language-icon" />
              <button
                className={`language-btn ${!checked ? 'active' : ''}`}
                onClick={() => handleChange(false)}
                title="English"
              >
                EN
              </button>
              <button
                className={`language-btn ${checked ? 'active' : ''}`}
                onClick={() => handleChange(true)}
                title="Irish"
              >
                GA
              </button>
            </div> */}
            {/* <RegionSwitcher /> */}
            <Nav.Link href="https://shop.hansa-flex.ie/" target="_blank" rel="noopener noreferrer">
              <FaShoppingCart />  {t("Online-Catalogue")}
            </Nav.Link>
            <Nav.Link href="https://my.hansa-flex.ie/" target="_blank" rel="noopener noreferrer">
              <FaCode />  {t("X-CODE Manager")}
            </Nav.Link>
          </div>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default MainNavbarMenu;
